import {Grid} from '@yandex-delivery/blocks'
import React, {useState} from 'react'

import {ControlPanelProps} from '../components/control-panel/ControlPanel.types'
import {ControlPanel} from '../components/control-panel/ControlPanel@desktop'
import {default as HeaderButton, HeaderButtonProps} from '../components/header-button/HeaderButton'
import LogoRuIcon from '../components/icons/LogoRuIcon'
import {headerClasses} from './Header@desktop.classes'

export type HeaderProps = {
  user: React.ReactNode
  linksList: Array<{
    label: React.ReactNode
    content: React.ReactNode
  }>
  buttonList?: Array<Pick<HeaderButtonProps, 'href' | 'variant' | 'size' | 'transparent'> & {label: React.ReactNode}>
} & ControlPanelProps

export function Header({controlPanelData, linksList, buttonList, user}: HeaderProps): React.ReactElement {
  const [linkState, setLinkState] = useState(false)
  const [linkContent, setLinkContent] = useState(0)

  return (
    <>
      <div className={headerClasses.header}>
        <nav className={headerClasses.firstLine}>
          <ControlPanel controlPanelData={controlPanelData} />
        </nav>
        <header className={headerClasses.secondLine} onMouseLeave={() => setLinkState(false)}>
          <Grid direction="column" wrap="nowrap" container>
            <Grid className={headerClasses.actionsPanel} justify="space-between" wrap="nowrap" container>
              <Grid alignItems="center" className={headerClasses.leftSide} wrap="nowrap" container>
                <Grid item>
                  <LogoRuIcon className={headerClasses.logo} />
                </Grid>
                <Grid className={headerClasses.linksList} wrap="nowrap" container item>
                  {linksList?.map((item, index) => (
                    <Grid
                      key={index}
                      onMouseEnter={() => {
                        setLinkState(true)
                        setLinkContent(index)
                      }}
                    >
                      <HeaderButton transparent={true} variant="pseudo">
                        {item.label}
                      </HeaderButton>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid alignItems="center" className={headerClasses.rightSide} wrap="nowrap" container>
                <Grid className={headerClasses.buttonList} wrap="nowrap" container item>
                  {buttonList?.map(({label, ...props}, index) => (
                    <HeaderButton key={index} {...props}>
                      {label}
                    </HeaderButton>
                  ))}
                </Grid>
                <Grid alignItems="center" className={headerClasses.buttonList} wrap="nowrap" item>
                  {user}
                </Grid>
              </Grid>
            </Grid>
            {linkState && linkContent !== undefined && (
              <Grid className={headerClasses.linksContent} item>
                {linksList[linkContent]?.content}
              </Grid>
            )}
          </Grid>
        </header>
      </div>
    </>
  )
}
